module.exports = __webpack_public_path__ + "img/10.d24bed25.jpg";